// Time-comunidade ativo: persistido no localStorage e sincronizado com URL.
// Fluxo:
//   getActiveTeamId(teams): 1) URL /time/{action}/:id → grava e retorna
//                           2) localStorage active_team_id → se ainda for dono
//                           3) teams[0] (fallback) — tambem grava
// Todas as telas do dono usam essa resolucao pra manter a escolha entre telas.

const KEY = 'active_team_id';

const URL_ACTIONS = ['dashboard', 'editar', 'upgrade', 'jogos'];

function urlTeamId() {
  const match = window.location.pathname.match(
    new RegExp(`/time/(?:${URL_ACTIONS.join('|')})/(\\d+)`)
  );
  return match ? parseInt(match[1], 10) : null;
}

function readStored() {
  const v = localStorage.getItem(KEY);
  const n = v ? parseInt(v, 10) : null;
  return Number.isFinite(n) ? n : null;
}

export function setActiveTeamId(id) {
  if (!Number.isFinite(id)) return;
  localStorage.setItem(KEY, String(id));
  window.dispatchEvent(new CustomEvent('active_team_changed', { detail: { team_id: id } }));
}

// Resolve o time ativo dado a lista atual do dono. Grava no localStorage
// se URL ou fallback definirem valor novo. Retorna o objeto team completo.
export function resolveActiveTeam(teams) {
  if (!Array.isArray(teams) || teams.length === 0) return null;
  const fromUrl = urlTeamId();
  if (fromUrl) {
    const t = teams.find(x => x.id === fromUrl);
    if (t) {
      const stored = readStored();
      if (stored !== fromUrl) setActiveTeamId(fromUrl);
      return t;
    }
  }
  const stored = readStored();
  if (stored) {
    const t = teams.find(x => x.id === stored);
    if (t) return t;
  }
  // Fallback: primeiro time — grava pra proxima chamada nao ficar oscilando
  setActiveTeamId(teams[0].id);
  return teams[0];
}

export function getActiveTeamId() {
  return urlTeamId() || readStored() || null;
}
